import { buildCssClassName } from "@/3514/utils"
import { type IUseTranslation, useTranslation } from "@/hooks"

import "./styles.scss"

type Props = {
    styles?: any
    snapshot?: any
    withStyles?: boolean
    className?: string
}

const DragElement = ({ snapshot: snapshotRef, className = "", withStyles = true, styles: _styles }: Props) => {
    const { t }: IUseTranslation = useTranslation()

    return (
        <div
            className={buildCssClassName("drag-element [cursor:grab]", className, { "no-styles": !withStyles })}
            ref={snapshotRef}
            aria-label={t("common.ariaLabels.dndElement")}
        >
            <svg width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="4.64082" cy="5.3083" r="1.071" fill="#6F6F6F" />
                <circle cx="4.64082" cy="10.0007" r="1.071" fill="#6F6F6F" />
                <circle cx="4.64082" cy="14.6921" r="1.071" fill="#6F6F6F" />
                <circle cx="9.63887" cy="5.3083" r="1.071" fill="#6F6F6F" />
                <circle cx="9.63887" cy="10.0007" r="1.071" fill="#6F6F6F" />
                <circle cx="9.63887" cy="14.6921" r="1.071" fill="#6F6F6F" />
            </svg>
        </div>
    )
}

export default DragElement
